import Modal from "components/foundation/Modal/Modal";
import React from "react";
import styled from "styled-components";

interface SaveWarningModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const SaveWarningModal = ({
  isOpen,
  onConfirm,
  onCancel,
}: SaveWarningModalProps) => {
  return (
    <Modal.Root open={isOpen}>
      <Modal.Body
        style={{ maxWidth: "38rem" }}
        title="수정된 내용이 저장되지 않았습니다."
        onCancel={onCancel}
        onConfirm={onConfirm}
      >
        <SaveWarningModalLayout>
          <h6>확인 버튼 클릭 시 변경 내용을 저장하지 않고 이동합니다.</h6>
          <p>
            수정된 내용의 저장을 원하실 경우,  취소 후 ‘등록’ 버튼을
            클릭해주세요.
          </p>
        </SaveWarningModalLayout>
      </Modal.Body>
    </Modal.Root>
  );
};

export default SaveWarningModal;

const SaveWarningModalLayout = styled.div`
  h6 {
    ${({ theme }) => theme.typography.body1.medium}
    color: ${({ theme }) => theme.color.icon.middleEmphasis};
    margin-bottom: 2rem;
  }

  p {
    ${({ theme }) => theme.typography.body1.regular}
    color: ${({ theme }) => theme.color.text.secondary};
  }
`;
